export type Doing = "started" | "joined" | "left" | "ended";

export type Press = { what: Doing; about: string; at: number };

export const A_MOMENT = 6000;

export function noted(presses: readonly Press[], press: Press): Press[] {
  return [...presses.filter((one) => press.at - one.at < A_MOMENT), press];
}

export function wasMine(
  presses: readonly Press[],
  what: Doing,
  about: string,
  now: number,
): { mine: boolean; presses: Press[] } {
  const at = presses.findIndex((one) => one.what === what && one.about === about && now - one.at < A_MOMENT);
  if (at === -1) return { mine: false, presses: [...presses] };
  return { mine: true, presses: presses.filter((_, index) => index !== at) };
}

let presses: Press[] = [];

export function pressed(what: Doing, about: string, at = Date.now()): void {
  presses = noted(presses, { what, about, at });
}

export function wasThatMine(what: Doing, about: string, now = Date.now()): boolean {
  const asked = wasMine(presses, what, about, now);
  presses = asked.presses;
  return asked.mine;
}
